import { PrerequisiteRuleTypes, type ExtensionConfig } from '@goto/shell-common'
import { getFeatureFlag } from '../helpers/shell-helpers'

export const extensionConfig: ExtensionConfig = {
  id: '@ucc/gtc-cc-qm-scorecard.widgets',
  get url() {
    const version = getFeatureFlag('sai-scorecard-widgets-version', 'latest')
    return new URL(`/experiences/cc-qm-scorecard-widgets/${version}/goto-app-extension.js`, location.origin)
  },
  prerequisites: {
    [PrerequisiteRuleTypes.SHELL_FEATURE_FLAGS]: 'insights.enable',
  },
  integrations: {
    msTeams: {
      shouldLoadInIntegration: false,
    },
    sidePanel: {
      shouldLoad: true,
    },
  },
}

export default extensionConfig
